export default __webpack_public_path__ + "static/logo-baafa6e09db3c38d5639961fc16c0088.gif";